import React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../common/Card';
import Badge from '../common/Badge';
import Button from '../common/Button';
import { formatDate } from '../../utils/helpers';
import { theme } from '../../config/theme';

const SellerCard = ({ seller }) => {
  const navigate = useNavigate();

  const getStatusVariant = (status) => {
    const map = {
      pending: 'warning',
      under_review: 'info',
      approved: 'success',
      rejected: 'error',
    };
    return map[status] || 'default';
  };

  const infoRowStyles = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.spacing.md,
    marginTop: theme.spacing.md,
    marginBottom: theme.spacing.md,
  };

  const labelStyles = {
    fontSize: theme.typography.fontSize.xs,
    color: theme.colors.text.secondary,
    marginBottom: theme.spacing.xs,
  };

  return (
    <Card hoverable onClick={() => navigate(`/admin/sellers/${seller.id}`)}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: theme.spacing.md }}>
        <div>
          <h3 style={{ fontSize: theme.typography.fontSize.lg, fontWeight: theme.typography.fontWeight.semibold, marginBottom: theme.spacing.xs }}>
            {seller.store_name}
          </h3>
          <Badge variant={getStatusVariant(seller.onboarding_status)}>
            {seller.onboarding_status?.replace('_', ' ').toUpperCase()}
          </Badge>
        </div>
      </div>

      <div style={infoRowStyles}>
        <div>
          <div style={labelStyles}>Email</div>
          <div>{seller.user?.email}</div>
        </div>
        <div>
          <div style={labelStyles}>Phone</div>
          <div>{seller.user?.phone}</div>
        </div>
        <div>
          <div style={labelStyles}>Business Type</div>
          <div>{seller.business_type}</div>
        </div>
        <div>
          <div style={labelStyles}>Applied On</div>
          <div>{formatDate(seller.created_at)}</div>
        </div>
      </div>

      <Button 
        size="sm" 
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/admin/sellers/${seller.id}`);
        }}
      >
        Review Application
      </Button>
    </Card>
  );
};

export default SellerCard;